
import React, { useState, useMemo } from "react";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import SoftDrinkDpEdit from "./SoftDrinkDpEdit";

function SoftDrinkEdit() {


  const getCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const date = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${date}`;
  };

  const getFirstDayOfMonth = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}-01`;
  };


  const [fromDate, setFromDate] = useState(getFirstDayOfMonth());
  const [toDate, setToDate] = useState(getCurrentDate());

  const handleFromDateChange = (value) => {
    setFromDate(value);
    if (value > toDate) {
      setToDate(value);
    }
  };

  const handleToDateChange = (value) => {
    if (value < fromDate) return;
    setToDate(value);
  };


  return (
    <Box minH="100vh" bg="gray.50" pt={{ base: "10vh", md: "13vh" }}>
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align={{ base: "flex-start", md: "center" }}
        mb={8}
      >
        <Box>
          <Heading size="lg" color="gray.800" mb={2}>
            Store Level Report
          </Heading>
          <Text color="gray.500">
            Track assortments and stock health across every location
          </Text>
        </Box>

        <Flex alignItems="center" gap={4} >
          {/* FROM DATE */}
          <Box minW="220px" >
            <Text fontSize="md" color="gray.800" fontWeight="bold" mb={1} mx={2}>
              From Date
            </Text>
            <Box
              as="input"
              type="date"
              value={fromDate}
              max={toDate}
              onChange={(e) => handleFromDateChange(e.target.value)}
              sx={{
                width: "100%",
                padding: "8px 12px",
                borderRadius: "8px",
                border: "1px solid",
                borderColor: "gray.300",
                bg: "white",
                fontSize: "16px",
                cursor: "pointer",
                "&:focus": {
                  outline: "none",
                  borderColor: "red.500",
                  boxShadow: "0 0 0 3px rgba(244, 0, 9, 0.3)",
                },
              }}

            />
          </Box>

          {/* TO DATE */}
          <Box minW="220px">
            <Text fontSize="md" fontWeight="bold" mb={1} color="gray.800" mx={2}>
              To Date
            </Text>
            <Box
              as="input"
              type="date"
              value={toDate}
              min={fromDate}
              onChange={(e) => handleToDateChange(e.target.value)}
              sx={{
                width: "100%",
                padding: "8px 12px",
                borderRadius: "8px",
                border: "1px solid",
                borderColor: "gray.300",
                bg: "white",
                fontSize: "16px",
                cursor: "pointer",
                "&:focus": {
                  outline: "none",
                  borderColor: "red.500",
                  boxShadow: "0 0 0 3px rgba(244, 0, 9, 0.3)",
                },
              }}
            />
          </Box>
        </Flex>
      </Flex>
      <SoftDrinkDpEdit
        fromDate={fromDate}
        toDate={toDate} />
    </Box>
  );
}

export default SoftDrinkEdit;

